module.exports = __webpack_public_path__ + "static/media/Wooden-door.6015696e.jpg";